<template>
  <el-form class="section-filter" :model="filterForm" :inline="true" label-width="110px">

    <div class="filter-grid">
      <template v-if="!filterItemsArea.fShow">
        <el-form-item :class="filterItemsArea.key" :label="filterItemsArea.label+'：'" :prop="filterItemsArea.key" class="hide">
          <AreaPicker ref="AreaPicker" @change="areaChange" @getData="filterClick" />
        </el-form-item>
      </template>

      <el-form-item :class="x1.key" :label="x1.label+'：'" :prop="x1.key" v-for="(x1,i1) in filterItemsShow" :key="i1">

        <template v-if="x1.key==='fixed-area'">
          <AreaPicker ref="AreaPicker" @change="areaChange" @getData="filterClick" />
        </template>

        <template v-else>
          <FormItem :x1="x1" :row="filterForm" typeKey="f" />
        </template>

      </el-form-item>
    </div>

    <div class="filter-btn">
      <el-button type="primary" @click="filterClick()" icon="el-icon-search">查询</el-button>
      <el-button type="" @click="resetClick()" icon="el-icon-refresh-right">重置</el-button>
    </div>
  </el-form>
</template>

<script>
import AreaPicker from '@/components/AreaPicker'
import FormItem from '@/components/XY/FormItem'
export default {
  components: { AreaPicker, FormItem },
  props: {
    formItems: { type: Array, default: () => [] },
    filterForm: { type: Object, default: () => {} },
    areaChange: { type: Function, default: () => {} },
    filterClick: { type: Function, default: () => {} },
    resetClick: { type: Function, default: () => {} },
  },
  data() {
    return {
      rowStyle: 'width:200px;',
    }
  },
  computed: {
    filterItemsShow() {
      return this.formItems.filter(x1 => !x1.fHide && x1.fShow).sort((a, b) => a['fIndex'] - b['fIndex'])
    },
    filterItemsArea() {
      return this.formItems.find(x1 => x1.key === 'fixed-area') || {}
    },
  },
  created() {
    for (const e of this.formItems) {
      const defaultValue = e.fDefault || e.default
      if (defaultValue) {
        if (typeof defaultValue === 'function') {
          this.$set(this.filterForm, e.key, defaultValue())
        } else {
          this.$set(this.filterForm, e.key, defaultValue)
        }
      }
    }
  },
}
</script>

<style lang='scss' scoped>
.section-filter{
  display: flex;overflow-x: auto;

  &>div{flex-shrink: 0;}
  .filter-grid{
    display: grid;
    grid-auto-flow: column; /* 元素按列方向填充 */
    grid-template-rows: repeat(3, auto); /* 强制每列最多3行 */
    gap: 0; /* 元素间距 */
    .fixed-area{
      grid-row: span 3;
    }
  }

  .filter-btn{margin: 0 20px;}
}

.hide{width: 0;height: 0;overflow: hidden;}

/deep/ .el-form-item__label,
/deep/ .el-radio__label {font-size: 12px;}
/deep/ .el-input--mini .el-input__icon {line-height: 36px;} // 选择器 icon位置
/deep/.el-select__tags{overflow: auto;}
</style>